import { tokens } from '@kdk/shared/theme';
import { Box } from '@mui/material';
import type { ReactNode } from 'react';

type Item = { label: string; value: ReactNode };

export const KeyValueList = ({ items }: { items: readonly Item[] }) => (
  <Box
    component="dl"
    sx={{ display: 'grid', gridTemplateColumns: '92px 1fr', gap: '4px 10px', m: 0, fontSize: 13 }}
  >
    {items.map((item) => (
      <Box key={item.label} sx={{ display: 'contents' }}>
        <Box component="dt" sx={{ color: tokens.dim }}>
          {item.label}
        </Box>
        <Box component="dd" sx={{ m: 0 }}>
          {item.value}
        </Box>
      </Box>
    ))}
  </Box>
);
